"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const tiktok = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-tiktok` : '') + (description ? ` desc-tiktok` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-tiktok"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-tiktok"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_1932)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM19 10.5613C17.6238 10.5645 16.2814 10.1354 15.1623 9.3344V14.9207C15.1616 17.0395 13.8461 18.9353 11.8616 19.6777C9.87708 20.42 7.64022 19.8531 6.24894 18.2551C4.85766 16.6572 4.60406 14.3637 5.61262 12.5004C6.62118 10.6371 8.68015 9.59517 10.7789 9.88609V12.6958C9.81687 12.3932 8.76932 12.7432 8.18231 13.5632C7.59531 14.3832 7.60181 15.4876 8.19843 16.3006C8.79506 17.1137 9.84666 17.4512 10.8051 17.1373C11.7635 16.8234 12.4116 15.9292 12.4116 14.9207V4H15.1623C15.1604 4.23229 15.1799 4.46426 15.2205 4.69298C15.4137 5.72489 16.0231 6.63177 16.9057 7.20045C17.5269 7.6112 18.2552 7.83013 19 7.82998V10.5613Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_1932"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = tiktok;